import { adPriceTypes } from 'Core/constants'

export const getPriceTypeTitle = priceType => {
  let priceTypeTitle = null
  if (priceType) {
    for (const type in adPriceTypes) {
      if (adPriceTypes.hasOwnProperty(type) && adPriceTypes[type].id === Number(priceType)) {
        priceTypeTitle = adPriceTypes[type].title
        break
      }
    }
  }

  return priceTypeTitle
}
